// src/components/auth/ProtectedRoute.tsx
import React from 'react';
import { useAppSelector } from '../../app/hooks';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute: React.FC = () => {
    const { isAuthenticated } = useAppSelector((state) => state.auth);

    // If authenticated, render the child routes (<Outlet />).
    // Otherwise, redirect to the login page.
    return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;